import Lines from '../components/common/Lines';
import ProgressScroll from '../components/common/ProgressScroll';
import Cursor from '../components/common/cusor';
import LoadingScreen from '../components/common/loader';
import Footer from '../components/common/Footer';
import Navbar from '../components/common/Navbar';
import { Helmet } from 'react-helmet';
import FaviconLinks from '../components/common/FaviconLinks';
import Header from '../components/portfolio-details/Header';
import PortfolioDetail from '../components/portfolio-details/PortfolioDetail';
import WOW from 'wowjs';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';
import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getAllPortfolios, getPortfolioById } from '../common/portfolioStore';

gsap.registerPlugin(useGSAP, ScrollTrigger);

export default function PortfolioDetailsPage() {
  const main = useRef();
  const { id } = useParams();
  const [item, setItem] = useState(null);
  const [allItems, setAllItems] = useState([]);

  useEffect(() => {
    const load = async () => {
      try {
        const items = await getAllPortfolios();
        setAllItems(items);
        if (id) {
          setItem(await getPortfolioById(id));
        } else if (items.length > 0) {
          window.location.href = `/portfolio-details/${items[0].id}`;
        }
      } catch (err) {
        console.error(err);
      }
    };
    load();
  }, [id]);

  useEffect(() => {
    const loadScript = (src) =>
      new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.onload = () => resolve(true);
        script.onerror = () => reject(new Error(`Failed to load ${src}`));
        document.body.appendChild(script);
      });

    loadScript('/assets/js/gsap.min.js')
      .then(() => loadScript('/assets/js/ScrollSmoother.min.js'))
      .then(() => loadScript('/assets/js/smoother-script.js'))
      .catch((error) => console.error(error.message));
  }, []);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      new WOW.WOW({ animateClass: 'animated', offset: 100 }).init();
    }
  }, []);

  const pageTitle = item
    ? `${item.title} ${item.titleHighlight || ''} — Kanus Digital`
    : 'Portfolio — Kanus Digital';

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <FaviconLinks />
        <link rel="stylesheet" type="text/css" href="/assets/css/plugins.css" />
        <link rel="stylesheet" type="text/css" href="/assets/css/style.css" />
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css?family=Poppins:100,200,300,400,500,600,700,800,900&display=swap"
        />
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@200;300;400;500;600;700&display=swap"
        />
        <script src="/assets/js/ScrollTrigger.min.js" defer />
        <script src="/assets/js/ScrollSmoother.min.js" defer />
        <script defer src="/assets/js/gsap.min.js"></script>
        <script defer src="/assets/js/splitting.min.js"></script>
        <script defer src="/assets/js/isotope.pkgd.min.js"></script>
        <script defer src="/assets/js/plugins.js"></script>
        <script defer src="/assets/js/TweenMax.min.js"></script>
        <script defer src="/assets/js/charming.min.js"></script>
        <script defer src="/assets/js/countdown.js"></script>
      </Helmet>
      <body>
        <LoadingScreen />
        <Cursor />
        <ProgressScroll />
        <Lines />
        <Navbar />
        <div id="smooth-wrapper" ref={main}>
          <div id="smooth-content">
            <main className="main-bg">
              <Header item={item} />
              <PortfolioDetail item={item} allItems={allItems} />
            </main>
            <Footer />
          </div>
        </div>
      </body>
    </>
  );
}
